import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#336bdc"
    }
  }
});

export default theme;
